export const environment = {
  apiUrl: 'https://api.ilop.nl',
};
